module.exports = __webpack_public_path__ + "img/splash-3.d087e291.png";